module.exports = __webpack_public_path__ + "img/racoon-hand.978c8ee.3d7e9194.png";